import React, { Component } from 'react'
import { Modal, Form, Input, Button } from 'antd'

class groupCreateModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: '',
      loading: false
    }
  }

  handleOk = (e) => {
    e.preventDefault()

    this.setState({
      error: '',
      loading: true
    })

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.createGroup({
          name: values.name
        }).then((response) => {
          if (response && !response.data.error) {
            this.handleCancel()
          } else {
            this.setState({
              error: response.data.error.message
            })
          }

          this.setState({
            loading: false
          })
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }

  handleCancel = (e) => {
    this.setState({
      error: '',
      loading: false
    })
    this.props.closeModal()
  }

  render () {
    const { getFieldDecorator } = this.props.form

    const layout = {
      labelCol: {
        md: { span: 8 }
      },
      wrapperCol: {
        md: { span: 16 }
      }
    }

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Add a Group'
        visible={this.props.status}
        onCancel={this.handleCancel}
        destroyOnClose
        width={380}
        footer={[
          <Button key='back' onClick={this.handleCancel}>Cancel</Button>,
          <Button key='submit' type='indigo' loading={this.state.loading} onClick={this.handleOk}>Create</Button>
        ]}
      >
        { this.state.error.length > 0 ? <div className='form__error'>{ this.state.error }</div> : '' }

        <Form onSubmit={this.handleOk} className='form'>
          <Form.Item {...layout} label='Name'>
            {getFieldDecorator('name', {
              rules: [{ required: true,
                message: 'Please input group name',
                max: 23,
                pattern: /^[^, ][ a-zA-Z_\\-\\.0-9]*/
              }]
            })(
              <Input name='name' maxLength={23} />
            )}
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}

export default Form.create()(groupCreateModal)



// WEBPACK FOOTER //
// ./src/components/Modals/GroupCreateModal/GroupCreateModal.jsx